import { useAppSelector } from '@app/hooks';
import { label } from '@entities/ksp/format';
import { useGetKspExportQuery } from '@shared/api/endpoints/ksp';
import { downloadAuthorizedFile } from '@shared/lib/downloadFile';
import { Button } from '@shared/ui/Button';
import { Notice, Small } from '@widgets/ksp-workspace/parts';

export function ExportStatus({ id, onError }: { id: string; onError: (text: string) => void }) {
  const token = useAppSelector((state) => state.auth.accessToken);
  const { data } = useGetKspExportQuery(id, { pollingInterval: 2000 });
  const download = async () => {
    if (!data?.file_url) return;
    const result = await downloadAuthorizedFile(data.file_url, {
      accessToken: token,
      fallbackName: 'КСП',
    });
    if (!result.ok) onError(`Не удалось скачать файл: ${result.error}`);
  };
  return (
    <Notice>
      Выгрузка: {label(data?.status ?? 'queued')}
      {data?.error && <Small>{data.error}</Small>}
      {data?.operation_count != null && (
        <Small>
          Работ: {data.operation_count}
          {data.page_count != null && `; страниц: ${data.page_count}`}
        </Small>
      )}
      {data?.file_sha256 && <Small>SHA-256 {data.file_sha256}</Small>}
      {data?.file_url && <Button onClick={download}>Скачать</Button>}
    </Notice>
  );
}
